<template>
  <div v-if="pagination && pagination.links && pagination.meta && !!pagination.meta.from && !!pagination.meta.to">
    <button
      v-if="pagination.meta.current_page < pagination.meta.last_page && showMore"
      class="btn btn-gray btn-submit show-more-block"
      @click="loadMore(pagination.links.next, true)"
      :disabled="isLoading"
    >
      <span class="show-more">Show more <span class="tick"></span></span>
    </button>

    <div class="pagination" v-if="pagination.elements && showPagination">
      <ul class="pagination-list">
        <li v-if="!pagination.links.prev" class="disabled pg-item" aria-disabled="true">
          <span aria-hidden="true">&lsaquo;</span>
        </li>
        <li v-else class="pg-item">
          <button type="button" rel="prev" @click="loadMore(pagination.links.prev)" :disabled="isLoading">
            &lsaquo;
          </button>
        </li>

        <template v-for="(element, key) in pagination.elements">
          <li
            v-if="typeof element === 'string'"
            :key="'button_' + key"
            class="disabled pg-divider"
            aria-disabled="true"
          >
            <span>{{ element }}</span>
          </li>
          <template v-else v-for="(url, page) in element">
            <li
              v-if="page == pagination.meta.current_page"
              class="active pg-item"
              aria-current="page"
              :key="'button_' + key + '_' + page + '_active'"
            >
              <span>{{ page }}</span>
            </li>
            <li v-else class="pg-item" :key="'button_' + key + '_' + page">
              <button type="button" @click="loadMore(url)" :disabled="isLoading">{{ page }}</button>
            </li>
          </template>
        </template>

        <li v-if="pagination.links.next" class="pg-item">
          <button type="button" rel="next" @click="loadMore(pagination.links.next)" :disabled="isLoading">
            &rsaquo;
          </button>
        </li>
        <li v-else class="disabled pg-item" aria-disabled="true">
          <span aria-hidden="true">&rsaquo;</span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: "Pagination",
  props: {
    paginator: Object,
    showMore: {
      type: Boolean,
      default: false,
    },
    showPagination: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      pagination: this.paginator,
      isLoading: false,
    };
  },
  mounted() {},
  methods: {
    loadMore(url, append = false) {
      if (this.isLoading) {
        return;
      }

      this.isLoading = true;

      axios
        .get(url)
        .then((response) => {
          if (window.history && history.replaceState && !append) {
            const urlParams = new URL(url).searchParams;

            var newUrl = window.location.pathname,
              queryStr = urlParams.toString();

            if (queryStr) {
              newUrl += "?" + queryStr.replaceAll("%5B%5D=", "[]=");
            }

            history.replaceState(null, "", newUrl);
          }

          this.$emit("onLoadMore", {
            data: response.data,
            append: append,
          });

          this.pagination = {
            links: response.data.links,
            meta: response.data.meta,
            elements: response.data.elements,
          };
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
  watch: {
    paginator(pagination) {
      this.pagination = pagination;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./html/src/sass/include/_vars.scss";

.show-more-block {
}
.show-more-block {
  width: 100%;
  margin-bottom: 20px;

  //padding: 25px;
  //text-align: center;
  //cursor: pointer;
  //background-color: $gray-light;
  //border-radius: 6px;
  //
  //font-size: 14px;
  //font-weight: bold;
  //display: block;
  //text-decoration: none;
  //.show-more {
  //  position: relative;
  //  display: inline;
  //  text-decoration: none;
  //}
}

.pagination {
  margin: 0 auto;
  min-width: 280px;
  max-width: 480px;
  .pagination-list {
    display: flex;
    justify-content: center;
    margin-bottom: 200px;
    @media (max-width: 767px) {
      margin-bottom: 200px;
    }
    .pg-item,
    .pg-divider {
      font-size: 14px;
      margin: 0 4px;
      a,
      button,
      span {
        display: block;
      }
      a,
      button {
        padding: 10px;
        text-decoration: none;

        &:hover {
          border-bottom: 2px solid $green;
          padding: 10px 10px 8px 10px;
          box-sizing: border-box;
          transition: color ease 0.2s;
        }
      }

      &.disabled {
        span {
          padding: 10px;
        }
      }
    }

    .pg-divider {
      span {
        padding: 10px;
      }
    }
    .active {
      border-bottom: 2px solid $green;
      padding: 10px 10px 8px 10px;
    }
  }
}
</style>
